<template>
  <div class="sbu-teaser" id="neuesbu">
    <!-- <div class="grid-container nopadding"> -->
      <div class="section-1">
        <div class="grid-x">
          <div class="cell small-12 large-6 small-order-2 large-order-1 relative padd">
            <h1 class="big-title mt-1">Die neue ERGO BU: Im grünen Bereich für extra-günstig.</h1>
            <p class="teaser-text">Leistungsstarke Absicherung? Das ist für Ihre Kunden doch selbst-verständlich. Für ERGO auch. Doch vor allem für junge Menschen gilt: Geld spielt eine Rolle. Genau damit punktet die neue ERGO BU, denn sie ist besonders günstig – vor und nach dem Berufsstart. </p>
          </div>
          <div class="cell small-12 large-6  small-order-1 large-order-2 relative">
            <!-- TODO iframe App -->
            <img class="center-block" src="@/assets/blumenlady.jpg" />
          </div>
        </div>
      </div>
      <div class="section-2">
        <div class="grid-x with-gap">
          <div class="cell small-12 large-4 relative">
            <div class="card">
                <h3>Mega-niedrige Einstiegsbeiträge</h3>
                <p>und damit eine niedrige „Abschlusshürde“</p>
            </div>
          </div>
          <div class="cell small-12 large-4 relative">
            <div class="card">
                <h3>Keine krassen Preissprünge nach Berufsstart</h3>
                <p>dank langfristiger, gestaffelter Beitragsanpassung</p>
            </div>
          </div>
          <div class="cell small-12 large-4 relative no-margin">
            <div class="card">
                <h3>Für Akademiker ein Leben lang extra-günstig</h3>
                <p>vor allem für BWLer/VWLer, Juristen und Mediziner</p>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'SbuTeaser',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="stylus" scoped>
  .section-1 {
    background-color #CCEBED
    .padd {
      padding 15em 6.8em 0 4.3em
     
      @media screen and (max-width: 39.9375em) {
        padding 3.75em 1.7em 2.8em
      }
    }
  }
  .section-2 {
    background-color #A9DAE0
    padding 5.1em 4.2em

    @media screen and (max-width: 39.9375em) {
      padding 3.3em 1.7em
    }
  }

  .grid-x {
    .cell.large-4 {
      width 31%
      margin-right 2.86em

      @media screen and (max-width: 39.9375em) {
        width 100%
        margin-bottom 1.67em
      }

      &.no-margin {
        margin-right 0
      }
    }
  }
  
  .big-title {
    font-size 3.5em
    line-height: 1.2
    font-family: 'FedraSerifAPro'
    font-weight bold
    color #8E0038

    @media screen and (max-width: 39.9375em) {
      font-size 2.2em
    }
  }

  .card {
    padding 1.8em 4.3em
    height 100%
    justify-content center;
    //align-items center;
    border-radius .4em
    box-shadow 0 0.4em 1em 0.2em rgba(0,0,0,0.3)

    @media screen and (max-width: 39.9375em) {
      padding 1.5em
    }

    h3 {
      font-family: 'FedraSerifAPro'
      font-size 2em
      font-weight bold
      color #8E0038
      line-height 1.21em
      text-align center
    }

    p {
      text-align center
    }
  }
</style>